<template>
  <div class="artist-layout min-h-screen flex flex-col bg-background text-text-main" :class="{ 'has-player': !!currentTrack }">
    <!-- Same fixed plate the storefront uses: an artist subdomain is a
         shop surface, so it wears the shop's ground rather than a flat
         one. Decorative, never intercepts the pointer. -->
    <div class="artist-backdrop" aria-hidden="true"></div>
    <main class="flex-1 w-full relative z-10">
      <slot />
    </main>
    <AppFooter />
    <!-- The storefront's player, not the panel one. An artist subdomain
         is a shop surface: the same queue, the same visualizer, the same
         controls the buyer already knows — and both read the same
         useAudioPlayer state, so a preview started here survives the hop
         to shop.{tenant}. GlobalAudioPlayer stays where it belongs, in
         the admin and creator panels. -->
    <ShopMasterPlayer />
    <ShopQueueDrawer />
  </div>
</template>

<script setup>
// Clearance for the floating bar is conditional, unlike the shop's
// unconditional 120px: this page is deliberately short, and reserving a
// player's worth of empty space on a profile where nothing is playing
// would spend a tenth of a phone screen on nothing.
const { currentTrack } = useAudioPlayer()
</script>

<style scoped>
/* Minimal layout without header — the profile brings its own chrome. */
.artist-backdrop {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  /* Scrim first (it paints over the plate), then the plate itself. */
  background-image:
    linear-gradient(
      to bottom,
      rgb(3 3 4 / 0.80) 0%,
      rgb(3 3 4 / 0.90) 45%,
      rgb(3 3 4 / 0.97) 100%
    ),
    url('/images/night-market-bg.webp');
  background-size: cover, cover;
  background-position: center top, center top;
  background-repeat: no-repeat, no-repeat;
  background-attachment: scroll, fixed;
}

@media (max-width: 600px) {
  .artist-backdrop { background-attachment: scroll, scroll; }
}

.artist-layout :deep(.app-footer) {
  position: relative;
  z-index: 10;
}

/* 76px bar + 18px shell padding + breathing room, so the footer's last
   row is never pinned under the floating player. */
.artist-layout.has-player {
  padding-bottom: 104px;
}
</style>
